import React from 'react';
import { Box, Typography } from '@mui/material';

const UnauthorizedAccess = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', heigth: '100%' }}>
        <Typography variant="body2">Access Denied | Please contact admin</Typography>
    </Box>
);

export default UnauthorizedAccess;
